// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";
import {
  dateSchema,
  LoadEvent,
  loadEventSchema,
  Overwrite,
} from "../commonSchemas";

export const path = "get-loads";

export const loadState = z.enum([
  "Not Assigned",
  "Assigned",
  "Being Picked Up",
  "In Transit",
  "Delivered",
  "Cancelled",
]);

export const loadSchema = z.object({
  id: z.string(),
  name: z.string(),
  createdAt: dateSchema,
  sourceLocation: z.string(),
  destinationLocation: z.string(),
  pickupStart: dateSchema.nullable(),
  pickupEnd: dateSchema.nullable(),
  deliveryEta: dateSchema.nullable(),
  deliveryStart: dateSchema.nullable(),
  deliveryEnd: dateSchema.nullable(),
  status: loadState,
  weight: z.number().nullable(),
  receiverCost: z.number().nullable(),
  carrierId: z.string().nullable(),
  carrierPay: z.number().nullable(),
  carrierName: z.string().nullable(),
  driverName: z.string().nullable(),
  driverLicenseNumber: z.string().nullable(),
  truckLicensePlate: z.string().nullable(),
  truckVinLast6: z.string().nullable(),
  trailerLicensePlate: z.string().nullable(),
  trailerNumber: z.string().nullable(),
  pieces: z.number().nullable(),
  notes: z.string().nullable(),
  bol: z.string().nullable(),
  events: z.array(loadEventSchema),
});

export const getLoadsResponseSchema = z.array(loadSchema);




export type LoadState = z.infer<typeof loadState>;

export type Load = Overwrite<z.infer<typeof loadSchema>, "events", LoadEvent[]>;

export type GetLoadsResponse = z.infer<typeof getLoadsResponseSchema>;




// receiver/get-loads endpoint
export function getLoads(
): Promise<GetLoadsResponse> {
  return requestHandler(
    "receiver/get-loads",
    undefined,
    getLoadsResponseSchema,
  );
}

